import { first, last } from 'lodash';
import { extendMoment } from 'moment-range';
import moment from 'moment-timezone';

import asArray from 'utils/arrays/asArray.util';
import fromArrayToLength from 'utils/converters/array/fromArrayToLength.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import compareStartTimes from 'lib/sortTimesAscending.util';

const L = logger('calculateRangeOfWorkingHours');
const USE_DEBUG_LOG = false;

const calculateRangeOfWorkingHours = withOptions(({ openingHours: openingHoursFromOptions, currentDate, step, procedures: proceduresFromOptions }) => {
  const procedures = asArray(proceduresFromOptions);
  const weekday = moment(currentDate).weekday();
  const openingHours = asObject(asArray(openingHoursFromOptions)[weekday]);

  const formattedBgn = moment(openingHours.open_time, 'hh:mm:ss');
  const formattedEnd = moment(openingHours.close_time, 'hh:mm:ss');

  const bgnHour = formattedBgn.get('hour');
  const bgnMinute = formattedBgn.get('minute');
  const endHour = formattedEnd.get('hour');
  const endMinute = formattedEnd.get('minute');

  let bgn = moment(currentDate).set({ hour: bgnHour, minute: bgnMinute, second: 0, millisecond: 0 });
  let end = moment(currentDate).set({ hour: endHour, minute: endMinute, second: 0, millisecond: 0 });

  const currentDayProcedures = procedures.filter((p) => moment(p.start_time).isSame(currentDate, 'day')).sort(compareStartTimes);

  const count = fromArrayToLength(currentDayProcedures);

  if (count > 0) {
    const firstProcedureTime = moment(first(currentDayProcedures).start_time);
    const lastProcedureTime = moment(last(currentDayProcedures).start_time);

    if (firstProcedureTime.isBefore(bgn)) {
      const quartersPassed = Math.floor(firstProcedureTime.minute() / 15);
      firstProcedureTime.minute(quartersPassed * 15);
      const firstHour = firstProcedureTime.get('hour');
      const firstMinute = firstProcedureTime.get('minute');

      bgn = moment(currentDate).set({ hour: firstHour, minute: firstMinute, second: 0, millisecond: 0 });
    }

    if (lastProcedureTime.isAfter(end)) {
      const extended = moment(lastProcedureTime).add(moment.duration(last(currentDayProcedures).duration));
      end = moment(extended).set({ second: 0, millisecond: 0 });
    }
  }

  const result = Array.from(extendMoment(moment).range(moment(bgn).subtract(1, 'hours'), moment(end).add(1, 'hours')).by('minutes', { step }));

  if (USE_DEBUG_LOG)
    L.debug(
      '()',
      'result:',
      result.map((m) => m.toISOString()),
    );

  return result;
});

export default calculateRangeOfWorkingHours;
